import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import ja from 'date-fns/locale/ja'

import { Button } from '~/atoms/button/Button'
import { InformationText } from '~/atoms/text/InformationText'
import { ProgressStep } from '~/atoms/progess/ProgressStep'
import { StepProgress } from '~/molecules/progress/StepProgress'

import { formatDateString } from '@/utils/dateFormat'

import * as Style from './style.css'

export interface IProps {
  isTokyoBsWaiting?: boolean
  isTokyoBsTmpUse?: boolean
  isReportBack?: boolean
  user: IUser
  formAuthenticityToken: string
  reserve: IReserveSummary
  options?: string
  totalPrice: number
  priceDetails: IReservePriceDetail[]
  extendTotal: number
  extendReason?: string
  startAt: string
  endAt: string
  priceDetailsString?: string
  optionText?: string
  additionalChildOption?: IAdditionalChildOption
  transportation?: string
  schedule?: string
  childrenMood?: string
  comment?: string
  messageOnReportInputLong?: string
  editSupportDateUrl: string
  editPriceUrl: string
  editReportUrl: string
  editScheduleUrl: string
  editChildrenMoodUrl: string
  editCommentUrl: string
  editTokyoBsTmpUseUrl: string
  submitUrl: string
  backUrl: string
  showSittingPhotos?: boolean
  sittingPhotos?: IReserveSittingPhoto[]
}

const DATE_FORMAT = 'yyyy年MM月dd日(E) HH:mm'

export const SittingReportStep3 = ({
  isTokyoBsWaiting,
  isTokyoBsTmpUse,
  isReportBack,
  user,
  formAuthenticityToken,
  reserve,
  options,
  totalPrice,
  priceDetails,
  extendTotal,
  extendReason,
  startAt,
  endAt,
  priceDetailsString,
  optionText,
  additionalChildOption,
  transportation,
  schedule,
  childrenMood,
  comment,
  messageOnReportInputLong,
  editSupportDateUrl,
  editPriceUrl,
  editReportUrl,
  editScheduleUrl,
  editChildrenMoodUrl,
  editCommentUrl,
  editTokyoBsTmpUseUrl,
  submitUrl,
  backUrl,
  showSittingPhotos,
  sittingPhotos,
}: IProps): JSX.Element => {
  return (
    <div className={Style.SittingReportStep3}>
      <StepProgress>
        <ProgressStep isActive={true}>サポート情報</ProgressStep>
        <ProgressStep isActive={true}>レポート情報</ProgressStep>
        <ProgressStep isActive={true}>入力内容確認</ProgressStep>
      </StepProgress>
      <h1 className={Style.SittingReportStep3Title}>STEP3. 入力内容確認</h1>
      <p className={Style.SittingReportStep3Description}>
        下記の内容で送信します。問題なければ「完了報告を送る」ボタンを押してください。
      </p>
      <div className={Style.SittingReportStep3Section}>
        <div className={Style.SittingReportStep3SectionHead}>
          <p className={Style.SittingReportStep3SectionTitle}>サポート日付</p>
          <a
            href={editSupportDateUrl}
            className={Style.SittingReportStep3SectionAction}
          >
            編集
          </a>
        </div>
        <div className={Style.SittingReportStep3SectionRow}>
          <div className={Style.SittingReportStep3SectionRowHead}>
            <p className={Style.SittingReportStep3SectionRowTitle}>開始日時</p>
          </div>
          <p className={Style.SittingReportStep3SectionRowContent}>
            {formatDateString(startAt, DATE_FORMAT, ja)}
          </p>
        </div>
        <div className={Style.SittingReportStep3SectionRow}>
          <div className={Style.SittingReportStep3SectionRowHead}>
            <p className={Style.SittingReportStep3SectionRowTitle}>終了日時</p>
          </div>
          <p className={Style.SittingReportStep3SectionRowContent}>
            {formatDateString(endAt, DATE_FORMAT, ja)}
          </p>
        </div>
      </div>
      {isTokyoBsWaiting && additionalChildOption && (
        <div className={Style.SittingReportStep3Section}>
          <div className={Style.SittingReportStep3SectionHead}>
            <p className={Style.SittingReportStep3SectionTitle}>
              追加でお預りしたお子様の帰宅時刻
            </p>
            <a
              href={editSupportDateUrl}
              className={Style.SittingReportStep3SectionAction}
            >
              編集
            </a>
          </div>
          <div className={Style.SittingReportStep3SectionRow}>
            <div className={Style.SittingReportStep3SectionRowHead}>
              <p className={Style.SittingReportStep3SectionRowTitle}>
                帰宅日時
              </p>
            </div>
            <p className={Style.SittingReportStep3SectionRowContent}>
              {formatDateString(
                additionalChildOption.actual_apply_start_at,
                'HH:mm',
                ja,
              )}
            </p>
          </div>
        </div>
      )}
      {!isReportBack && (
        <>
          <div className={Style.SittingReportStep3Section}>
            <div className={Style.SittingReportStep3SectionHead}>
              <p className={Style.SittingReportStep3SectionTitle}>サポート費</p>
              <a
                href={editPriceUrl}
                className={Style.SittingReportStep3SectionAction}
              >
                編集
              </a>
            </div>
            <div className={Style.SittingReportStep3SectionRow}>
              <div className={Style.SittingReportStep3SectionRowHead}>
                <p className={Style.SittingReportStep3SectionRowTitle}>
                  オプション料金
                </p>
              </div>
              <p
                className={Style.SittingReportStep3SectionRowContent}
                dangerouslySetInnerHTML={{ __html: optionText }}
              ></p>
            </div>
            <div className={Style.SittingReportStep3SectionRow}>
              <div className={Style.SittingReportStep3SectionRowHead}>
                <p className={Style.SittingReportStep3SectionRowTitle}>
                  交通費(往復)または経費
                </p>
              </div>
              <p
                className={Style.SittingReportStep3SectionRowContent}
                dangerouslySetInnerHTML={{ __html: transportation }}
              ></p>
            </div>
          </div>
          <div className={Style.SittingReportStep3Section}>
            <div className={Style.SittingReportStep3SectionHead}>
              <p className={Style.SittingReportStep3SectionTitle}>
                完了報告レポート
              </p>
            </div>
            <div className={Style.SittingReportStep3SectionRowSingle}>
              <div className={Style.SittingReportStep3SectionRowHead}>
                <p className={Style.SittingReportStep3SectionRowTitle}>
                  サポートスケジュール
                </p>
                <a
                  href={editScheduleUrl}
                  className={Style.SittingReportStep3SectionRowAction}
                >
                  編集
                </a>
              </div>
              <p
                className={Style.SittingReportStep3SectionRowContent}
                dangerouslySetInnerHTML={{ __html: schedule }}
              />
            </div>
            <div className={Style.SittingReportStep3SectionRowSingle}>
              <div className={Style.SittingReportStep3SectionRowHead}>
                <p className={Style.SittingReportStep3SectionRowTitle}>
                  生活や遊び時のお子様の様子
                </p>
                <a
                  href={editChildrenMoodUrl}
                  className={Style.SittingReportStep3SectionRowAction}
                >
                  編集
                </a>
              </div>
              <p
                className={Style.SittingReportStep3SectionRowContent}
                dangerouslySetInnerHTML={{ __html: childrenMood }}
              />
            </div>
            <div className={Style.SittingReportStep3SectionRowSingle}>
              <div className={Style.SittingReportStep3SectionRowHead}>
                <p className={Style.SittingReportStep3SectionRowTitle}>
                  連絡事項
                </p>
                <a
                  href={editCommentUrl}
                  className={Style.SittingReportStep3SectionRowAction}
                >
                  編集
                </a>
              </div>
              <p
                className={Style.SittingReportStep3SectionRowContent}
                dangerouslySetInnerHTML={{ __html: comment }}
              />
            </div>
            {isTokyoBsTmpUse && (
              <div className={Style.SittingReportStep3SectionRowSingle}>
                <div className={Style.SittingReportStep3SectionRowHead}>
                  <p className={Style.SittingReportStep3SectionRowTitle}>
                    お子様のお預かり状況
                  </p>
                  <a
                    href={editCommentUrl}
                    className={Style.SittingReportStep3SectionRowAction}
                  >
                    編集
                  </a>
                </div>
                <p className={Style.SittingReportStep3SectionRowContent}>
                  {reserve.tokyo_bs_tmp_use_report === 'single_child' && (
                    <>お子様1人のみを預かった</>
                  )}
                  {reserve.tokyo_bs_tmp_use_report === 'mixed_children' && (
                    <>未就学児1人と就学児をサポーター1名で預かった</>
                  )}
                  {reserve.tokyo_bs_tmp_use_report === 'group_care' && (
                    <>複数の未就学児を保護者と一緒に共同保育した</>
                  )}
                  {reserve.tokyo_bs_tmp_use_report === 'non_group_care' && (
                    <>複数の未就学児を預かったが共同保育ではなかった</>
                  )}
                  {reserve.tokyo_bs_tmp_use_report ===
                    'multiple_schooled_children' && (
                    <>複数の就学児童のみをサポーター1名で預かった</>
                  )}
                </p>
              </div>
            )}
          </div>
        </>
      )}
      {isReportBack && (
        <>
          <div className={Style.SittingReportStep3Section}>
            <div className={Style.SittingReportStep3SectionHead}>
              <p className={Style.SittingReportStep3SectionTitle}>
                完了報告レポート
              </p>
            </div>
            <div className={Style.SittingReportStep3SectionRowSingle}>
              <div className={Style.SittingReportStep3SectionRowHead}>
                <p className={Style.SittingReportStep3SectionRowTitle}>
                  連絡事項
                </p>
                <a
                  href={editCommentUrl}
                  className={Style.SittingReportStep3SectionRowAction}
                >
                  編集
                </a>
              </div>
              <p
                className={Style.SittingReportStep3SectionRowContent}
                dangerouslySetInnerHTML={{ __html: messageOnReportInputLong }}
              />
            </div>
          </div>
          <div className={Style.SittingReportStep3Section}>
            <div className={Style.SittingReportStep3SectionHead}>
              <p className={Style.SittingReportStep3SectionTitle}>コメント</p>
              <a
                href={editReportUrl}
                className={Style.SittingReportStep3SectionAction}
              >
                編集
              </a>
            </div>
            <div className={Style.SittingReportStep3SectionRowSingle}>
              <div className={Style.SittingReportStep3ReportBackComment}>
                <div className={Style.SittingReportStep3ReportBackCommentInfo}>
                  <img
                    className={
                      Style.SittingReportStep3ReportBackCommentThumbnail
                    }
                    src={user.image.middle_thumb.url}
                  />
                  <div
                    className={Style.SittingReportStep3ReportBackCommentStatus}
                  >
                    再報告
                  </div>
                </div>
                <div
                  className={Style.SittingReportStep3ReportBackCommentContent}
                >
                  {comment}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showSittingPhotos && (
        <div className={Style.SittingReportStep3Section}>
          <div className={Style.SittingReportStep3SectionHead}>
            <p className={Style.SittingReportStep3SectionTitle}>
              サポート中の写真
            </p>
          </div>
          <div className="panel-front-contents">
            <ul className={Style.SittingReportStep3SittingPhotos}>
              {sittingPhotos.map((sittingPhoto, index) => (
                <li
                  className={Style.SittingReportStep3SittingPhoto}
                  key={`sitting-photo-${index}`}
                >
                  <div className={Style.SittingReportStep3SittingPhotoWrapper}>
                    <div
                      className={Style.SittingReportStep3SittingPhotoImage}
                      style={{
                        backgroundImage: `url(${sittingPhoto.url})`,
                      }}
                    ></div>
                  </div>
                  {sittingPhoto.caption && (
                    <p className={Style.SittingReportStep3SittingPhotoCaption}>
                      {sittingPhoto.caption}
                    </p>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <div className={Style.SittingReportStep3Section}>
        <div className={Style.ReservePriceInfo}>
          <div className={Style.ReservePriceInfoTotal}>
            <span className={Style.ReservePriceInfoTotalText}>
              受取金額合計
            </span>
            <span className={Style.ReservePriceInfoTotalPrice}>
              {totalPrice.toLocaleString()}
            </span>
            <span className={Style.ReservePriceInfoTotalUnit}>円</span>
          </div>
          <div className={Style.ReservePriceInfoTotalDetail}>
            <div className={Style.ReservePriceInfoTotalDetailTitle}>内訳</div>
            <div className={Style.ReservePriceInfoTotalDetailContents}>
              {priceDetails.map((detail, index) => (
                <>
                  {detail[0] !== 'オプション料金' && (
                    <div className={Style.ReservePriceInfoTotalDetailRow}>
                      <div
                        className={Style.ReservePriceInfoTotalDetailRowTitle}
                      >
                        <p
                          className={
                            Style.ReservePriceInfoTotalDetailRowTitleText
                          }
                        >
                          {detail[0]}
                          {!!detail[2] && (
                            <label
                              className={Style.ReservePriceInfoExplainLabel}
                              htmlFor={`priceDetail${index}`}
                            >
                              <FontAwesomeIcon
                                className={
                                  Style.ReservePriceInfoExplainLabelIcon
                                }
                                icon={faInfo}
                              />
                            </label>
                          )}
                        </p>
                        {!!detail[2] && (
                          <>
                            <input
                              id={`priceDetail${index}`}
                              type="checkbox"
                              className={Style.ReservePriceInfoExplainCtrl}
                            />
                            <div className={Style.ReservePriceInfoExplain}>
                              <p
                                className={
                                  Style.ReservePriceInfoExplainTextPirce
                                }
                              >
                                {detail[2]}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <div
                        className={Style.ReservePriceInfoTotalDetailRowContents}
                      >
                        {detail[1].toLocaleString()}円
                      </div>
                    </div>
                  )}
                  {detail[0] === 'オプション料金' && (
                    <div>
                      <div
                        className={Style.ReservePriceInfoTotalDetailRowNoBorder}
                      >
                        <div
                          className={Style.ReservePriceInfoTotalDetailRowTitle}
                        >
                          <p
                            className={
                              Style.ReservePriceInfoTotalDetailRowTitleText
                            }
                          >
                            オプション料金
                          </p>
                        </div>
                        <div
                          className={
                            Style.ReservePriceInfoTotalDetailRowContents
                          }
                        >
                          {detail[1].toLocaleString()}円
                        </div>
                      </div>
                      <div
                        className={Style.ReservePriceInfoTotalDetailOptionName}
                      >
                        {detail[2]}
                      </div>
                    </div>
                  )}
                </>
              ))}
            </div>
            {extendTotal > 0 && (
              <div className={Style.ReservePriceInfoAlert}>
                <InformationText title="延長料金が発生しています" color="alert">
                  {extendReason}
                </InformationText>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={Style.SittingReportStep3Actions}>
        <form action={submitUrl} method="POST">
          <input type="hidden" name="_method" value="patch" />
          <input
            type="hidden"
            value={formAuthenticityToken}
            name="authenticity_token"
          />
          <input
            type="hidden"
            value={reserve.id}
            name="reserve[id]"
            id="reserve_id"
          />
          <input
            type="hidden"
            value={reserve.actual_start_at}
            name="reserve[actual_start_at]"
          />
          <input
            type="hidden"
            value={reserve.actual_end_at}
            name="reserve[actual_end_at]"
          />
          <input
            type="hidden"
            value={reserve.actual_transportation_price}
            name="reserve[actual_transportation_price]"
          />
          <input type="hidden" value={options} name="reserve[actual_options]" />
          <input
            type="hidden"
            value={reserve.actual_transportation_price_description}
            name="reserve[actual_transportation_price_description]"
          />
          <input
            type="hidden"
            value={reserve.support_shorted_reason}
            name="reserve[support_shorted_reason]"
          />
          <input
            type="hidden"
            value={reserve.support_shorted_reason_comment}
            name="reserve[support_shorted_reason_comment]"
          />
          <input
            type="hidden"
            value={schedule}
            name="reserve[sitting_report_schedule]"
          />
          <input
            type="hidden"
            value={childrenMood}
            name="reserve[sitting_report_children_mood]"
          />
          {isReportBack && (
            <input
              type="hidden"
              value={messageOnReportInputLong}
              name="reserve[message_on_report_input_long]"
            />
          )}
          <input
            type="hidden"
            value={comment}
            name="reserve_comment[comment]"
          />
          {isTokyoBsTmpUse && (
            <input
              type="hidden"
              value={reserve.tokyo_bs_tmp_use_report}
              name="reserve_comment[tokyo_bs_tmp_use_report]"
            />
          )}
          {isTokyoBsWaiting && additionalChildOption && (
            <>
              <input
                autoComplete="off"
                type="hidden"
                name="reserve[additional_child_option_attributes][id]"
                value={additionalChildOption.id}
              />
              <input
                autoComplete="off"
                type="hidden"
                name="reserve[additional_child_option_attributes][actual_apply_start_at]"
                value={formatDateString(
                  additionalChildOption.actual_apply_start_at,
                  'yyy-MM-dd HH:mm:00 +0900',
                  ja,
                )}
              />
            </>
          )}
          <Button type="submit" color="primary">
            完了報告を送る
          </Button>
        </form>
        <div className={Style.SittingReportStep3ActionBack}>
          <a className={Style.SittingReportStep3ActionBackLink} href={backUrl}>
            戻る
          </a>
        </div>
      </div>
    </div>
  )
}
